<template>
  <div class="uplus-back" id="uplus">
    <div class="uplus-content">
      <div class="left">用心连接，U+服务</div>
      <a
        :href="jumpLinkObj.uPlusURL"
        class="aboutUPlus"
        target="_blank"
        rel="noreferrer,noopener"
        >About U+</a
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      jumpLinkObj: {} // cms中配置的相关跳转地址
    }
  },
  created() {
    this.getJumpURL()
  },
  mounted() {},
  methods: {
    // 获取cms中配置的跳转地址
    getJumpURL() {
      axios
        .get(
          `/r/cms/www/openplatWeb/homeJSON/indexUrl.json?timestamp=${Math.round(new Date().getTime()/(1000*60*10))}`
        )
        .then((res) => {
          this.jumpLinkObj = res.data
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.uplus-back {
  width: 100%;
  height: 200px;
  background: url('~@/assets/index/uplus-bg.png');
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  z-index: 2;
  .uplus-content {
    width: 1200px;
    height: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
  }
  .left {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 500;
    padding-left: 80px;
  }
  .aboutUPlus {
    margin-right: 128px;
    height: 32px;
    width: 128px;
    background: #5e97ff;
    border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 1);
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #fff;
    letter-spacing: 0;
    text-align: center;
    line-height: 32px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 5px 10px 0px rgba(0, 76, 255, 0.5);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/components/uplus/connect.vue